import { styled } from '@mui/material';

import { UiCard } from '@ui/atoms-card';

import { AdditionalInfo } from '../AdditionalInfo/AdditionalInfo';
import { CardContent } from '../CardContent/CardContent';

import type { WrapperProps } from './Wrapper.types';

export function Wrapper({
  children,
  onChangeClick,
  disabled,
  isLoading,
  iconUrl,
  changeLabel,
  sectionAriaLabel,
  additionalInfoProps,
  changeButtonTestId,
  changeButtonAriaLabel,
  ...rest
}: WrapperProps) {
  const {
    children: additionalInfoChildren,
    variant: additionalInfoVariant = 'info',
  } = additionalInfoProps || {};

  return (
    <StyledCard disablePadding aria-label={sectionAriaLabel} {...rest}>
      <CardContent
        disabled={disabled || isLoading}
        isLoading={isLoading}
        iconUrl={iconUrl}
        onChangeClick={onChangeClick}
        changeLabel={changeLabel}
        changeButtonTestId={changeButtonTestId}
        changeButtonAriaLabel={changeButtonAriaLabel}
      >
        {children}
      </CardContent>
      <AdditionalInfo variant={additionalInfoVariant}>
        {additionalInfoChildren}
      </AdditionalInfo>
    </StyledCard>
  );
}

const StyledCard = styled(UiCard)({
  flexDirection: 'column',
});
